module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0028.jpg?v=52bb1db6";